<script>
export default {
  name: "mission-values",
};
</script>


<template>
  <section class="mission-values" id="mission-values">
    <div class="container">
      <header>
        <h2>Missão e valores</h2>
        <p>Trabalhamos sempre buscando proporcionar maior prazer estético, melhor qualidade de vida e<br />serviço mais impressionante em todas as nossas marcas e produtos.<br />Lideramos o nosso negócio, pela inovação e rentabilidade,<br />o setor de moda e lifestyle do país.</p>
      </header>
      <div class="row boxes-valores">
        <div class="col-12 col-md-4">
          <div class="box">
            <img src="@/assets/images/valores/1.svg" alt="" />
            <h3>Clientes</h3>
            <p>Trabalhamos sempre buscando proporcionar maior prazer estético, melhor qualidade de vida e serviço mais impressionante em todas as nossas marcas e produtos.<br />
            Lideramos o nosso negócio, pela inovação e rentabilidade, o setor de moda e lifestyle do país.</p>
          </div>
        </div>
        <div class="col-12 col-md-4">
          <div class="box">
            <img src="@/assets/images/valores/2.svg" alt="" />
            <h3>Resultados</h3>
            <p>
              Obstinados pelo resultado, estamos sempre buscando mais. Com talento e energia para criar o novo, buscamos sempre surpreender e INOVAR é o nosso combustível, vamos até o fim quando encontramos uma oportunidade. Com práticas e esforços para trazer sempre os melhores resultados e assim, fazer a diferença.
            </p>
          </div>
        </div>
        <div class="col-12 col-md-4">
          <div class="box">
            <img src="@/assets/images/valores/3.svg" alt="" />
            <h3>Gente</h3>
            <p>
              Nossa equipe não fica de fora do objetivo de entregar o melhor resultado aos clientes. Selecionamos um por um, a dedo para realizar o melhor trabalho, juntos. O nosso profissional tem senso de urgência e é ousado. Otimista e persistente, entusiasma-se com seu próprio
            </p>
          </div>
        </div>
        <div class="col-12 col-md-4">
          <div class="box">
            <img src="@/assets/images/valores/4.svg" alt="" />
            <h3>Nosso Jeito</h3>
            <p>
              Com espírito de liderança e vontade de melhorar sempre, agimos como donos. Temos um imenso orgulho de tudo o que fazemos e um enorme prazer em cada realização. Confiamos em nossos talentos mas ao mesmo tempo a vontade de evoluir nunca acaba.
            </p>
          </div>
        </div>
        <div class="col-12 col-md-4">
          <div class="box">
            <img src="@/assets/images/valores/5.svg" alt="" />
            <h3>Ética</h3>
            <p>
              Integridade e honestidade estão no cerne do nosso negócio Juntos, apontamos sempre o melhor do outro e também em equilíbrio, tudo aquilo que precisa de um cuidado e atenção delicada, para assim entregar nosso trabalho com parceria e verdade. Essa transparência é refletida em cada detalhe do nosso produto final e serviço. 
            </p>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>


<style scoped lang="scss">
.mission-values {
  margin-top: 11rem;
  margin-bottom: 11rem;

  header {
    h2 {
      font-size: 40px;
      font-weight: bold;
      max-width: 730px;
      margin: 0 auto 24px auto;
      text-align: center;
    }

    p {
      font-size: 20px;
      font-weight: 400;
      color: theme-color(blue-ml);
      max-width: 1000px;
      margin: 0 auto 30px auto;
      text-align: center;
    }
  }

  .row {
    padding: 0px 0.5rem;
    & > div {
      padding: 0px 0.8rem;
      margin-top: 1.5rem;
      @include media-breakpoint-down(sm) {
        margin-top: 1rem;
      }
    }
  }

  .boxes-valores{
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }

  .box {
    height: 100%;
    box-shadow: 0px 4px 46px rgba(0, 0, 0, 0.15);
    border-radius: 2px;
    background-color: #fff;
    padding: 19px 35px;

    @include media-breakpoint-down(sm) {
      min-height: auto;
    }

    img {
      height: 80px;
    }

    h3 {
      font-size: 24px;
      margin: 16px 0px;
      display: block;
      font-weight: 700;
    }

    p {
      font-size: 18px;
      font-weight: 500;
      margin: 0;
    }
  }
}
</style>
